export default __webpack_public_path__ + "static/media/KawardhaBemetraDainikBhaskar.e31cdf38.jpeg";